import * as userSettings from "../actions/userSettings.js";

import {static as Immutable} from "seamless-immutable";
import {localStorageWritingReducer} from "../util/storage.js";

const defaultState = () => {
    return Immutable({
        currentLanguage: "no",   // Systemets förvalda språk (Se index.html)
        currentOwner: undefined,
        currentReceivingPoint: undefined,
        systemInfo: {
            country: undefined,
            currency: 127,
            dateFormat: 2,
            decimalSeparator: ".",
            language: undefined,
            nofDecimalsAmount: 2,
            nofDecimalsAreaM2: 2,
            nofDecimalsVolumeL: 3,
            nofDecimalsVolumeM3: 2,
            nofDecimalsWeightG: 1,
            nofDecimalsWeightKg: 3,
            nofSignificantDigits: 15,
            thousandSeparator: false,
            timeFormat: 1,
            timeFormatSecs: 4,
            timeZone: 5
        }
    });
};

const reducer = (state, action) => {
    switch (action.type) {

    case userSettings.SET_CURRENT_LANGUAGE:
        return Immutable.merge(state, {
            currentLanguage: action.language
        });
    default:
        return state;
    }
};

export default localStorageWritingReducer(reducer, defaultState, "app_userSettings", ["currentLanguage", "currentWagon", "currentReceivingPoint"]);